import { useApiData } from "@/hooks/useApiData";
import { Link } from "wouter";
import { Plus, Edit, Trash2, Star } from "lucide-react";
import api from "@/lib/api";
import type { BlogPost } from "@shared/types";

export default function BlogPostList() {
  const { data: posts, refetch } = useApiData<BlogPost[]>("/blog-posts");

  const handleDelete = async (id: number) => {
    if (!confirm("Delete this post?")) return;
    await api.delete(`/blog-posts/${id}`);
    refetch();
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-white font-[Rubik]">Blog Posts</h1>
        <Link
          href="/admin/blog-posts/new"
          className="inline-flex items-center gap-2 bg-[#66CDAA] hover:bg-[#57b899] text-[#0F172A] font-bold px-4 py-2 rounded-xl text-sm transition-colors"
        >
          <Plus className="w-4 h-4" /> New Post
        </Link>
      </div>

      <div className="space-y-2">
        {posts?.map((post) => (
          <div
            key={post.id}
            className="flex items-center gap-4 p-4 rounded-xl bg-white/[0.02] border border-white/5 hover:border-white/10 transition-colors"
          >
            {post.image && (
              <img
                src={post.image}
                alt=""
                className="w-16 h-12 object-cover rounded-lg shrink-0"
              />
            )}
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-white font-medium truncate">{post.title}</span>
                {post.featured && <Star className="w-3.5 h-3.5 text-[#66CDAA] shrink-0" />}
              </div>
              <div className="text-xs text-white/30 mt-0.5">
                {post.category} &middot; {post.date}
              </div>
            </div>
            <div className="flex gap-1 shrink-0">
              <Link
                href={`/admin/blog-posts/${post.id}`}
                className="p-2 text-white/30 hover:text-[#66CDAA] transition-colors"
              >
                <Edit className="w-4 h-4" />
              </Link>
              <button
                onClick={() => handleDelete(post.id)}
                className="p-2 text-white/30 hover:text-red-400 transition-colors"
              >
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          </div>
        ))}

        {posts?.length === 0 && (
          <div className="text-center py-12 text-white/30">No blog posts yet.</div>
        )}
      </div>
    </div>
  );
}
